import React, { useState } from 'react';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import { Table, IconButton, Button, Grid, Box, Tooltip, TablePagination, Typography, Popover, CircularProgress } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Edit, Delete } from '@material-ui/icons';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import * as RFIcon from 'react-feather';
import language from '../../languages';
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    tableHeadRow: {
        border: '1px solid rgba(196, 196, 196, 0.1)',
        boxSizing: 'border-box',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        '& .MuiTableCell-root': {
            color: '#09205C'
        }
    },
    tableRow: {
        '& .MuiTableCell-root': {
            padding: 8,
            color: 'rgba(2, 2, 2, 0.7)',
            borderBottom: "none"
        }
    },
    deleteTitle:{
        padding: '8px 16px',
        color: '#ffffff',
        backgroundColor: '#2735A4',
    },
    deleteButton: {
      color: '#2735A4',
      margin: '8px 8px;',
      textTransform: 'capitalize',
      borderColor: '#2735A4'
    },
    deleteConfirmButton: {
        color: '#ffffff',
        backgroundColor: '#3076CA',
        '&:hover': {
          backgroundColor: fade('#3076CA', 0.75),
        },
        margin: '8px 8px;',
        textTransform: 'capitalize'
    },
});


export default function BaseList(props) {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteRow, setDeleteRow] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    
    const { readOnly, pager, setPageNumber, setItemsPerPage, sidePanelDetailId, lang, meta, handleCustomAction } = props;
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const [extraInfoData, setExtraInfoData] = useState('');
    const [fetchingInfo, setFetchingInfo] = useState(false);
  
    const popoverHandleClick = async(event, doc) => {
        setFetchingInfo(true)
        setAnchorEl(event.currentTarget);
        const data = await meta.getExtraInfo(doc)
        if(data) {
            setExtraInfoData(data)
        }
        setFetchingInfo(false)
    };
  
    const popoverHandleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const popoverId = open ? 'simple-popover' : undefined;

    const handleChangePage = (event, newPage) => {
        const { setPageNumber } = props;
        setPageNumber(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        debugger;
        setRowsPerPage(parseInt(event.target.value, 10));
        //setPage(0);
    };
    
    return (
        <>
            {
                <ConfirmationDialog
                    dialogProps={{
                        open: deleteDialogOpen,
                        onClose: () => { },
                    }}
                    content={
                        <>
                        <div className={classes.deleteTitle}><Typography variant="h6" >{language[lang].Delete}</Typography></div>
                        <Box p={4} width='600px'>
                            <Box p={2} >
                            <Typography variant="subtitle2" >{language[lang].Confirm_Message} {props.meta.entityName}?</Typography>
                            </Box>
                        </Box>
                        </>
                    }
                    dismissiveAction={<Button variant="outlined" className={classes.deleteButton} onClick={() => { setDeleteRow(null); setDeleteDialogOpen(false) }}>{language[lang].Cancel}</Button>}
                    confirmingAction={<Button variant="contained" className={classes.deleteConfirmButton}  onClick={() => { props.onDelete(deleteRow); setDeleteDialogOpen(false) }}>{language[lang].Delete}</Button>}
                />
            }
            <TableContainer component={Box}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow className={classes.tableHeadRow}>
                            {
                                props.meta.table && props.meta.table.map((metaRow, i) => {
                                    if (metaRow.type == 'field' || metaRow.type == 'conditionField')
                                        return <TableCell key={i} align="left">{metaRow.label}</TableCell>
                                    else if (metaRow.type == 'action' && !readOnly)
                                        return <TableCell key={i} align="center">{metaRow.label}</TableCell>
                                    else if (metaRow.type == 'customAction' && !readOnly)
                                        return <TableCell key={i} align="center">{metaRow.label}</TableCell>
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(props.rows && props.rows.length > 0 && props.meta.table) ? props.rows.map((row, i) => (
                            <TableRow key={i} 
                                style={props.meta.displaySidePanel ? sidePanelDetailId == row.id  ? {backgroundColor: '#F3F6FF', cursor: 'pointer'} : {cursor: 'pointer'} : {}} 
                                className={classes.tableRow} 
                                onClick={() => props.meta.displaySidePanel ? props.showDetail(row) : {} } >
                                {
                                    props.meta.table.map((metaRow, j) => {
                                        if (metaRow.type == 'field') {
                                            return <TableCell key={j} align="left">{
                                                metaRow.render ?
                                                    metaRow.render(row)
                                                :
                                                    row[metaRow.name]
                                            }
                                                {
                                                    metaRow.showImg && <img src={row[metaRow.name]} alt="No Image" width="100" height="100" />
                                                }
                                            </TableCell>
                                        } else if (metaRow.type == 'action' && !readOnly) {
                                            return <TableCell key={j} align="center">
                                                {metaRow.actions.includes('edit') && <Tooltip title={language[lang].Edit} placement="bottom">
                                                    <IconButton aria-label="Edit" component="span"
                                                        onClick={() => props.onEdit(row)}>
                                                        <RFIcon.Edit color='#000000' strokeWidth={2} />
                                                    </IconButton>
                                                </Tooltip>}
                                                {metaRow.actions.includes('delete') && <Tooltip title={language[lang].Delete} placement="bottom">
                                                    <IconButton aria-label="Delete" component="span"
                                                        onClick={() => { setDeleteRow(row); setDeleteDialogOpen(true); }}>
                                                        <RFIcon.Trash2 color='#DE4646' strokeWidth={2} />
                                                    </IconButton>
                                                </Tooltip>}
                                                {metaRow.actions.includes('view') && <Tooltip title='View' placement="bottom">
                                                    <IconButton aria-label="View" component="span"
                                                        onClick={() => props.onView(row)}>
                                                        <RFIcon.Eye color='#DE4646' strokeWidth={2} />
                                                    </IconButton>
                                                </Tooltip>}
                                                {metaRow.actions.includes('other') && <Tooltip title='More Options' placement="bottom">
                                                    <IconButton aria-label="Other" component="span"
                                                        onClick={() => props.onView(row)}>
                                                        <RFIcon.FileText color='grey' strokeWidth={2} />
                                                    </IconButton>
                                                </Tooltip>}
                                                {row.infoTip && metaRow.actions.includes('info') && <Tooltip title={row.infoTip} placement="bottom">
                                                    <IconButton aria-label="Info" component="span"
                                                        onClick={() => props.onView(row)}>
                                                        <RFIcon.Info color='grey' strokeWidth={2} />
                                                    </IconButton>
                                                </Tooltip>}
                                                {meta.getExtraInfo && metaRow.actions.includes('extraInfo') && 
                                                <>
                                                    <Tooltip title='Get Extra Info' placement="bottom">
                                                        <IconButton aria-describedby={popoverId} aria-label="Extra Info" component="span"
                                                            onClick={(event) => popoverHandleClick(event, row)}>
                                                            <RFIcon.Info color='green' strokeWidth={2} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Popover
                                                        id={popoverId}
                                                        open={open}
                                                        anchorEl={anchorEl}
                                                        onClose={popoverHandleClose}
                                                        anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center',
                                                        }}
                                                        transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'center',
                                                        }}
                                                    >
                                                        {fetchingInfo ? 
                                                            <Typography variant="subtitle2" style={{padding: 8}}>Fetching Info. <CircularProgress size={16} /> </Typography>
                                                          : 
                                                            extraInfoData
                                                        }
                                                    </Popover>
                                                </>}

                                            </TableCell>

                                        } else if (metaRow.type == 'conditionField') {
                                            return <TableCell key={j} align="left">{row[metaRow.name] ? metaRow.textForTrue : metaRow.textForFalse}</TableCell>
                                        } else if (metaRow.type == 'customAction') {
                                            return <TableCell key={j} align="center">
                                            {
                                                metaRow.actions && metaRow.actions.length > 0 &&
                                                metaRow.actions.map((customAction, k) => {
                                                    return <Button key={k} variant="contained" color="primary"
                                                        disabled={customAction.isDisabled && customAction.isDisabled(row)}
                                                        onClick={() => handleCustomAction(customAction.code, row)}>
                                                            {customAction.label}
                                                    </Button>
                                                })
                                            }
                                            </TableCell>
                                        }
                                    })
                                }
                                {/*<TableCell component="th" scope="row">
                                {row.name}
                        </TableCell>*/}
                            </TableRow>

                        )) : <TableRow className={classes.tableRow}>
                                <TableCell align="right">
                                    {language[lang].No_Data}
                                </TableCell>
                            </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                // rowsPerPageOptions={[4, 12, 24]}
                rowsPerPageOptions={[12]}
                component="div"
                count={pager.totalCount}
                rowsPerPage={pager.itemsPerPage}
                page={pager.pageNo}
                onChangePage={(e, newPage) => setPageNumber(newPage)}
                onChangeRowsPerPage={(e) => setItemsPerPage(e.target.value)}
            />
        </>
    )
}

